import React from 'react';
import { connect } from 'react-redux';

// Global Actions
import {
    requestLoadCropsurePasswords,
    canceledLoadCropsurePasswords
} from 'services/cropsurePasswords/actions';

interface DispatchProps {
    requestLoadCropsurePasswords: typeof requestLoadCropsurePasswords;
    canceledLoadCropsurePasswords: typeof canceledLoadCropsurePasswords;
}

type Props = DispatchProps;

export class CropsurePasswordsRequest extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.requestLoadCropsurePasswords();
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.canceledLoadCropsurePasswords();
    }

    render(): null {
        return null;
    }
}

export default connect(null, {
    requestLoadCropsurePasswords,
    canceledLoadCropsurePasswords
})(CropsurePasswordsRequest);
